import { Logo } from "@platform/ui/components";
import { useCanAccessNewLogin } from "../lib/posthog/posthog.hooks";

interface PublicAppLayoutProps {
  children: React.ReactNode;
}

export function PublicAppLayout({ children }: PublicAppLayoutProps) {
  const canAccessNewLogin = useCanAccessNewLogin();

  if (!canAccessNewLogin) {
    return <PublicAppLayoutLegacy>{children}</PublicAppLayoutLegacy>;
  }

  return (
    <div className="min-h-dvh w-full">
      <header className="pointer-events-none absolute inset-x-0 top-0 z-10 flex justify-center p-6 lg:p-10">
        <Logo aria-label="BreakLine Logo" className="w-[124px] md:w-[142px]" />
      </header>
      {children}
    </div>
  );
}

function PublicAppLayoutLegacy({ children }: PublicAppLayoutProps) {
  return (
    <div className="min-h-dvh w-full">
      <header className="pointer-events-none absolute inset-0 z-10 p-6 lg:p-10">
        <Logo aria-label="BreakLine Logo" style={{ width: 176 }} />
      </header>
      {children}
    </div>
  );
}
